import React from 'react';
import { useReveal } from '../lib/useReveal';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="premium" className="bg-[#0a0a0a] py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" style={{
    scrollMarginTop: '80px'
  }} data-id="element-34">
      <div className="container mx-auto max-w-5xl" data-id="element-35">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-2 leading-tight text-[#eab308]" data-id="element-37">
            ELEGÍ TU MEGAPACK
          </h2>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch ${vis2 ? 'is-visible' : ''}`} data-id="element-38">
          {/* Premium Card — LEFT (recommended) */}
          <div className="relative rounded-xl p-5 sm:p-8 flex flex-col bg-gradient-to-b from-[#111111] to-[#0a0a0a] border-2 border-[#eab308]/50 shadow-[0_0_50px_rgba(234,179,8,0.15)]" data-id="element-39">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[10px] font-bold px-4 py-1 rounded-full shadow-lg z-20 whitespace-nowrap tracking-wider" data-id="element-40">
              ⭐ RECOMENDADO
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-41">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-2 leading-tight" data-id="element-42">
                🏆 MEGAPACK + KIT PROFESIONAL ⭐
              </h3>
              <p className="text-[#eab308] font-bold text-sm mb-4" data-id="element-43">
                6 Tomos + 6 Bonos + Módulo Consultorio Avanzado
              </p>
              <div className="bg-white/5 border border-white/10 rounded-lg p-3 mb-6 text-left" data-id="element-44">
                <p className="text-gray-300 text-sm leading-snug" data-id="element-45">
                  <span className="font-bold text-white" data-id="element-46">Ideal para:</span>{' '}
                  Practicar, atender clientes y armar tu consultorio holístico
                  profesional completo
                </p>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-47">
                <span className="text-gray-500 line-through text-lg font-bold" data-id="element-48">
                  $89.000
                </span>
                <p className="text-4xl sm:text-5xl font-extrabold text-[#eab308] leading-none mt-1" data-id="element-49">
                  $27.990 <span className="text-xl" data-id="element-50">ARS</span>
                </p>
              </div>
            </div>

            <a href="https://pagos.academiaholisticaargentina.com/cart/48480180371673:1" target="_blank" rel="noopener noreferrer" className="w-full block py-4 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-51">
              → QUIERO EL MEGAPACK + KIT PROFESIONAL
            </a>
          </div>

          {/* Base Card — RIGHT */}
          <div className="relative rounded-xl p-5 sm:p-8 flex flex-col bg-[#111111] border border-white/10" data-id="element-52">
            <div className="text-center mb-6 mt-2" data-id="element-53">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-2 leading-tight" data-id="element-54">
                📘 MEGAPACK BIODESCODIFICACIÓN INTEGRAL
              </h3>
              <p className="text-gray-400 font-bold text-sm mb-4" data-id="element-55">
                6 Tomos + 6 Bonos
              </p>
              <div className="bg-white/5 border border-white/10 rounded-lg p-3 mb-6 text-left" data-id="element-56">
                <p className="text-gray-300 text-sm leading-snug" data-id="element-57">
                  <span className="font-bold text-white" data-id="element-58">Ideal para:</span>{' '}
                  Formarse, comprender el método y empezar a aplicarlo desde el
                  primer día
                </p>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-59">
                <span className="text-gray-500 line-through text-lg font-bold" data-id="element-60">
                  $69.000
                </span>
                <p className="text-4xl sm:text-5xl font-extrabold text-white leading-none mt-1" data-id="element-61">
                  $19.990 <span className="text-xl" data-id="element-62">ARS</span>
                </p>
              </div>
            </div>

            <a href="https://pagos.academiaholisticaargentina.com/cart/48480179650777:1" target="_blank" rel="noopener noreferrer" className="w-full block py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-white/10 hover:bg-white/20 border border-white/20 hover:border-white/30 hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-63">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </div>
      </div>
    </section>;
}